import React, { useState } from 'react';

import { requestHandoff } from './handoff.js';
import { getConfig } from './runtime.js';

/**
 * One button per other product this person can open. Hidden when the
 * organisation does not have that product, or this person was not granted it.
 */
export default function AppSwitcher({ user }) {
  const [pendingKey, setPendingKey] = useState('');
  const [error, setError] = useState('');
  const current = getConfig()?.APP?.productKey || 'taskydo';
  const products = (user && user.products && user.products.products) || [];
  const others = products.filter(
    (item) => item.key !== current && item.org_enabled && item.user_access,
  );
  if (!others.length) return null;

  async function openProduct(other) {
    setPendingKey(other.key);
    setError('');
    try {
      const data = await requestHandoff(other.key, '/');
      if (data.redirect) window.location.assign(data.redirect);
    } catch (err) {
      setError(err.message || 'Could not switch apps.');
      setPendingKey('');
    }
  }

  return (
    <span style={{ display: 'inline-flex', gap: 8, marginRight: 8 }}>
      {others.map((other) => (
        <button
          key={other.key}
          type="button"
          className="ty-btn"
          onClick={() => openProduct(other)}
          disabled={pendingKey === other.key}
          title={error || `Open ${other.label}`}
        >
          {pendingKey === other.key ? 'Opening…' : other.label}
        </button>
      ))}
    </span>
  );
}
